import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    userinfo:
      localStorage["YLW_USERINFO"] && JSON.parse(localStorage["YLW_USERINFO"]), // 用户信息
    headerNavIndex: 0, // 当前激活的Header导航菜单的下标
    leftNavIndex: 1, // 当前激活的内页左侧菜单的下标
    searchword: "", // 搜索的作品名称
    metaInfo: {}, // 默认网站关键词
    publicdatas: {} // 公共信息
  },
  mutations: {
    // 更新用户信息
    updateUserInfo(state, userinfo) {
      state.userinfo = userinfo;
      localStorage["YLW_USERINFO"] = JSON.stringify(userinfo);
    },

    // 更新导航菜单下标
    updateHeaderNavIndex(state, index) {
      state.headerNavIndex = index;
    },

    // 更新左侧菜单下标
    updateLeftNavIndex(state, index) {
      state.leftNavIndex = index;
    },

    // 更新查询作品名称
    updatesearchword(state, index) {
      state.searchword = index;
    },

    CAHNGE_META_INFO(state, metaInfo) {
      state.metaInfo = metaInfo;
    },

    CAHNGE_PUBLIC_INFO(state, metaInfo) {
      state.publicdatas = publicdatas;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js